import Swiper from 'swiper'
import { EffectFade } from 'swiper/modules'

const swgInfoSlider = document.querySelector('.swg__info_swiper')

if (swgInfoSlider) {
    const swgSlider = new Swiper(swgInfoSlider, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        allowTouchMove: false,
        modules: [EffectFade],
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 0,
        },
        on: {
            init(swiper) {
                if (swiper.slides[0]) {
                    const imageAll = swiper.slides[0].querySelectorAll('.js-swg-info-image')
                    if (imageAll.length) {
                        imageAll[0].classList.add('_active')
                    }
                }
            },
        },
    })

    const triggers = document.querySelectorAll('.js-swg-slider-trigger');
    triggers.forEach((trigger, idx) => {
        trigger.addEventListener('click', () => {
            swgSlider.slideTo(idx);
        });
    });
}